import { Fragment, useRef, useState } from "react";
import { Accordion, AccordionCollapse, Button, Card } from "react-bootstrap";
import { Table } from "react-bootstrap";
import Loader from "react-loader-spinner";
import { BoxSeam, CheckLg, FileEarmarkPerson, Person, PersonBadge, PersonSquare, Tag, Tags, Tools } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { saveSystemSettings } from "../../store/api/SystemSettingsAPI";
import { setServiceComboItemsPop } from "../../store/api/Modals";
import ModalServiceComboItems from "./ModalServiceComboItems";
import ButtonLabel from "./ButtonLabel";


const DesignSystemSettings = (props) => {
    const { findCheckedSetting, findSetting } = props;
    const [pending, setPending] = useState(false);
    const settingValues = useRef({});
    const dispatch = useDispatch();
    const save = () => {
        setPending(true);
        dispatch(saveSystemSettings(settingValues.current, () => { setPending(false) }));
    }
    const setcmbItems = (str, i) => {
        settingValues.current["Services_ComboBoxExtAttr" + i + "_Items"] = str;
    }
    return (
        <Fragment>
            <ModalServiceComboItems />
            <div className="row">
                <Accordion defaultActiveKey="1">
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "rgb(215 226 237)" }}>
                            <FileEarmarkPerson size={18} />
                            &nbsp;
                            پرسنل/تکنسین ها/نمایندگان
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="row">
                                    <div className="form-group col-md-4">
                                        <Table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>نام مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2].map((i) =>
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_Title"] = e.target.value} />
                                                        </td>
                                                        <td>
                                                            <select className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_IsEnglish")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                <option value={false}>فارسی</option>
                                                                <option value={true}>انگلیسی</option>
                                                            </select>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>نام مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[3, 4].map((i) =>
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_Title"] = e.target.value} />
                                                        </td>
                                                        <td>
                                                            <select className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_IsEnglish")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                <option value={false}>فارسی</option>
                                                                <option value={true}>انگلیسی</option>
                                                            </select>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>نام مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[5, 6].map((i) =>
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_Title"] = e.target.value} />
                                                        </td>
                                                        <td>
                                                            <select className="tableRowInput"
                                                                defaultValue={findSetting("Staff_ExtAttr" + i + "_IsEnglish")}
                                                                onChange={e => settingValues.current["Staff_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                <option value={false}>فارسی</option>
                                                                <option value={true}>انگلیسی</option>
                                                            </select>
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Card.Body>

                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="2" style={{ backgroundColor: "rgb(202 216 204)" }}>
                            <Tools size={17} />
                            &nbsp;
                            سرویس ها
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <div className="row">
                                    <div className="col-md-6" style={{ paddingLeft: 0 }}>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px" }}>نمایش</th>
                                                    <th style={{ width: "110px" }}>نمایش در جستجو</th>
                                                    <th>عنوان مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2, 3, 4, 5].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "50px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ExtAttr" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsShown"] = e.target.checked}
                                                                /></td>
                                                            <td style={{ width: "110px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ExtAttr" + i + "_IsSearchable")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsSearchable"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Services_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Services_ExtAttr" + i + "_Title"] = e.target.value}
                                                            /></td>
                                                            <td>
                                                                <select className="tableRowInput"
                                                                    defaultValue={findCheckedSetting("Services_ExtAttr" + i + "_IsEnglish")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                    <option value={false}>فارسی</option>
                                                                    <option value={true}>انگلیسی</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-md-6">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px" }}>نمایش</th>
                                                    <th style={{ width: "110px" }}>نمایش در جستجو</th>
                                                    <th>عنوان مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[6, 7, 8, 9, 10].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "50px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ExtAttr" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsShown"] = e.target.checked}
                                                                /></td>
                                                            <td style={{ width: "110px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ExtAttr" + i + "_IsSearchable")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsSearchable"] = e.target.checked}
                                                                /></td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Services_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Services_ExtAttr" + i + "_Title"] = e.target.value}
                                                            /></td>
                                                            <td>
                                                                <select className="tableRowInput"
                                                                    defaultValue={findCheckedSetting("Services_ExtAttr" + i + "_IsEnglish")}
                                                                    onChange={e => settingValues.current["Services_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                    <option value={false}>فارسی</option>
                                                                    <option value={true}>انگلیسی</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 scThin" style={{ maxHeight: "316px", overflow: "auto", paddingLeft: 0 }}>
                                        <Table className="mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px", position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>نمایش</th>
                                                    <th style={{ width: "110px", position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>نمایش در جستجو</th>
                                                    <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>عنوان مشخصه لیستی</th>
                                                    <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>آیتم ها</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => {

                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "50px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ComboBoxExtAttr" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["Services_ComboBoxExtAttr" + i + "_IsShown"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td style={{ width: "110px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_ComboBoxExtAttr" + i + "_IsSearchable")}
                                                                    onChange={e => settingValues.current["Services_ComboBoxExtAttr" + i + "_IsSearchable"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Services_ComboBoxExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Services_ComboBoxExtAttr" + i + "_Title"] = e.target.value}
                                                            /></td>
                                                            <td>
                                                                <ButtonLabel key={i} findSetting={findSetting} index={i} setSettings={setcmbItems} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-md-6">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "50px" }}>نمایش</th>
                                                    <th style={{ width: "110px" }}>نمایش در جستجو</th>
                                                    <th>عنوان مشخصه منطقی</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2, 3, 4, 5, 6].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "50px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_CheckBoxExtAttr" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["Services_CheckBoxExtAttr" + i + "_IsShown"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td style={{ width: "110px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Services_CheckBoxExtAttr" + i + "_IsSearchable")}
                                                                    onChange={e => settingValues.current["Services_CheckBoxExtAttr" + i + "_IsSearchable"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Services_CheckBoxExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Services_CheckBoxExtAttr" + i + "_Title"] = e.target.value}
                                                            />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="form-group col-md-3">
                                        <label>زبان سریال محصول</label>
                                        <select className="form-control"
                                            defaultValue={findCheckedSetting("Services_ProductSerial_IsEnglish")}
                                            onChange={e => settingValues.current.Services_ProductSerial_IsEnglish = e.target.value}>
                                            <option value={false}>فارسی</option>
                                            <option value={true}>انگلیسی</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>زبان شماره گارانتی</label>
                                        <select className="form-control"
                                            defaultValue={findCheckedSetting("Services_GuaranteeCard_IsEnglish")}
                                            onChange={e => settingValues.current.Services_GuaranteeCard_IsEnglish = e.target.value}>
                                            <option value={false}>فارسی</option>
                                            <option value={true}>انگلیسی</option>
                                        </select>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="3" style={{ backgroundColor: "#bbc9fe" }}>
                            <PersonSquare size={18} />
                            &nbsp;
                            مشتری
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div className="row">
                                    <div className="col-md-6">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>نمایش</th>
                                                    <th>عنوان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2, 3, 4, 5].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "80px", verticalAlign: "middle" }}>{"مشخصه " + i}</td>
                                                            <td style={{ width: "30px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("Customer_ExtAttr" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["Customer_ExtAttr" + i + "_IsShown"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Customer_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Customer_ExtAttr" + i + "_Title"] = e.target.value}
                                                            />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="4" style={{ backgroundColor: "rgb(202 205 216)" }}>
                            <PersonBadge size={18} />
                            &nbsp;
                            مشتری بالقوه
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <div className="row">
                                    <div className="col-md-6">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>نمایش</th>
                                                    <th>عنوان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2, 3, 4, 5].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "80px", verticalAlign: "middle" }}>{"مشخصه " + i}</td>
                                                            <td style={{ width: "30px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("PreCustomer_Ext" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["PreCustomer_Ext" + i + "_IsShown"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("PreCustomer_Axt" + i)}
                                                                onChange={e => settingValues.current["PreCustomer_Axt" + i] = e.target.value}
                                                            />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-md-6">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>نمایش</th>
                                                    <th>عنوان مشخصه</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[6, 7, 8, 9, 10].map((i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ width: "80px", verticalAlign: "middle" }}>{"مشخصه " + i}</td>
                                                            <td style={{ width: "30px", verticalAlign: "middle" }}>
                                                                <input type="checkbox" className="form-check-input"
                                                                    defaultChecked={findCheckedSetting("PreCustomer_Ext" + i + "_IsShown")}
                                                                    onChange={e => settingValues.current["PreCustomer_Ext" + i + "_IsShown"] = e.target.checked}
                                                                />
                                                            </td>
                                                            <td><input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("PreCustomer_Axt" + i)}
                                                                onChange={e => settingValues.current["PreCustomer_Axt" + i] = e.target.value}
                                                            /></td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="5" style={{ backgroundColor: "rgb(216 205 202)" }}>
                            <BoxSeam size={18} />
                            &nbsp;
                            محصولات
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="5">
                            <Card.Body>
                                <div className="row">
                                    <div className="col-md-5">
                                        <Table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>نام مشخصه</th>
                                                    <th>زبان مشخصه</th>
                                                    <th>نمایش در جستجو</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {[1, 2].map((i) =>
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="text" className="tableRowInput"
                                                                defaultValue={findSetting("Product_ExtAttr" + i + "_Title")}
                                                                onChange={e => settingValues.current["Product_ExtAttr" + i + "_Title"] = e.target.value} />
                                                        </td>
                                                        <td>
                                                            <select className="tableRowInput"
                                                                defaultValue={findCheckedSetting("Product_ExtAttr" + i + "_IsEnglish")}
                                                                onChange={e => settingValues.current["Product_ExtAttr" + i + "_IsEnglish"] = e.target.value}>
                                                                <option value={false}>فارسی</option>
                                                                <option value={true}>انگلیسی</option>
                                                            </select>
                                                        </td>
                                                        <td style={{ width: "110px", verticalAlign: "middle" }}>
                                                            <input type="checkbox" className="form-check-input"
                                                                defaultChecked={findCheckedSetting("Product_ExtAttr" + i + "_IsSearchable")}
                                                                onChange={e => settingValues.current["Product_ExtAttr" + i + "_IsSearchable"] = e.target.checked} />
                                                        </td>
                                                    </tr>)}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="col-md-3">
                                        <Table style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ verticalAlign: "middle" }}>زبان نام کالا/محصول</td>
                                                    <td>
                                                        <select className="tableRowInput"
                                                            defaultValue={findCheckedSetting("Products_ProductName_IsEnglish")}
                                                            onChange={e => settingValues.current.Products_ProductName_IsEnglish = e.target.value}>
                                                            <option value={false}>فارسی</option>
                                                            <option value={true}>انگلیسی</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ verticalAlign: "middle" }}>زبان مدل کالا/محصول</td>
                                                    <td>
                                                        <select className="tableRowInput"
                                                            defaultValue={findCheckedSetting("Products_ProductModel_IsEnglish")}
                                                            onChange={e => settingValues.current.Products_ProductModel_IsEnglish = e.target.value}>
                                                            <option value={false}>فارسی</option>
                                                            <option value={true}>انگلیسی</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card className="mt-2">
                        <Accordion.Toggle as={Card.Header} eventKey="6" style={{ backgroundColor: "#dacad7" }}>
                            <Tags size={18} />
                            &nbsp;
                            عناوین و برچسب ها
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="6">
                            <Card.Body>
                                <div className="row">
                                    <div className="form-group col-md-3">
                                        <label>سرویس نصب</label>
                                        <input type="text" className="form-control"
                                            defaultValue={findSetting("TitlesAndLabels_InstallService")}
                                            onChange={e => settingValues.current.TitlesAndLabels_InstallService = e.target.value} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>سرویس تعمیر</label>
                                        <input type="text" className="form-control"
                                            defaultValue={findSetting("TitlesAndLabels_RepairService")}
                                            onChange={e => settingValues.current.TitlesAndLabels_RepairService = e.target.value} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>نصب</label>
                                        <input type="text" className="form-control"
                                            defaultValue={findSetting("TitlesAndLabels_Install")}
                                            onChange={e => settingValues.current.TitlesAndLabels_Install = e.target.value} />
                                    </div>
                                    <div className="form-group col-md-3">
                                        <label>تعمیر</label>
                                        <input type="text" className="form-control"
                                            defaultValue={findSetting("TitlesAndLabels_Repair")}
                                            onChange={e => settingValues.current.TitlesAndLabels_Repair = e.target.value} />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
            <Button className="mt-4 group-Btn-large" style={{ position: "sticky", bottom: "10px" }} variant="success" onClick={save} disabled={pending}>{pending === true && <Loader type="BallTriangle" color="white" width={20} height={20} style={{ display: "inline-block" }} />}{!pending && <CheckLg size={12} />}&nbsp;ذخیره تغییرات</Button>
        </Fragment>
    )
}
export default DesignSystemSettings;